import React, { useState } from 'react';
import logo from "../assets/Logo/WoaomLogo.png"; // Keeping the original logo import
import { Menu, X } from 'lucide-react';

function NavLite() {
  const [isOpen, setIsOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);

  return (
    <nav className="font-inter mx-auto h-auto w-full max-w-screen-2xl md:relative md:top-0">
      <div className="flex flex-col md:flex-row items-center justify-between px-6 py-6 md:px-10 md:py-4 xl:px-20 relative">

        {/* Logo on the Left */}
        <div className="flex-shrink-0">
          <a href="/">
            <img
              src={logo} // Using the imported logo
              alt="Woaom Web Design Logo"
              width="180"
              height="auto"
              className="mb-4 md:mb-0"
            />
          </a>
        </div>

        {/* Desktop Navigation and Contact Button */}
        <div className="hidden md:flex md:items-center md:space-x-8">

          {/* Navigation Links with Dropdowns */}
          <div className="flex flex-row space-x-6 font-semibold text-black uppercase">

            {/* Services Link */}
            <div
              className="relative inline-block"
              onMouseEnter={() => setOpenDropdown('services')}
              onMouseLeave={() => setOpenDropdown(null)}
            >
              <a href='/services' className="cursor-default inline-block backdrop-blur-sm text-white hover:text-[#c6884a] ">WORK WITH ME</a>
              {/* Dropdown content is commented out as per original code */}
            </div>

            {/* Client Work Link */}
            <div
              className="relative inline-block"
              onMouseEnter={() => setOpenDropdown('clientwork')}
              onMouseLeave={() => setOpenDropdown(null)}
            >
              <a href='/clientwork' className="cursor-default inline-block text-white backdrop-blur-sm hover:text-[#c6884a]">CLIENT WORK</a>
              {/* Dropdown content is commented out as per original code */}
            </div>

             {/* Template Shop Link */}
            <div
              className="relative inline-block"
              onMouseEnter={() => setOpenDropdown('template')}
              onMouseLeave={() => setOpenDropdown(null)}
            >
              <a href='/templateshop' className="cursor-default inline-block text-white backdrop-blur-sm hover:text-[#c6884a]">TEMPLATE SHOP</a>
              {/* Dropdown content is commented out as per original code */}
            </div>

            {/* About Link */}
            <div
              className="relative inline-block"
              onMouseEnter={() => setOpenDropdown('about')}
              onMouseLeave={() => setOpenDropdown(null)}
            >
              <a href='/about' className="cursor-default inline-block text-white backdrop-blur-sm hover:text-[#c6884a]">ABOUT</a>
              {/* Dropdown content is commented out as per original code */}
            </div>

          </div>

          {/* Contact Button */}
          <a
            className="rounded-full bg-[#CFF098] px-12 py-2 text-black border-[1px] border-black uppercase hover:opacity-60"
            href="/contact"
          >
            Inquire
          </a>
        </div>


        {/* Hamburger Menu on Right for Mobile */}
        <button
          className="absolute right-6 top-6 md:hidden text-white"
          onClick={() => setIsOpen(!isOpen)}
        >
          {isOpen ? <X size={30} /> : <Menu size={30} />}
        </button>

        {/* Mobile Menu - Updated Links and Transparent Background */}
        <div
          className={`${
            isOpen ? 'flex' : 'hidden'
          } flex-col items-center space-y-12 md:space-y-12 md:hidden font-bold text-white backdrop-blur-lg p-5 w-full absolute top-full left-0 z-40`}
        >
          <a href="/services" className="uppercase hover:underline ">WORK WITH ME</a>
          <a href="/clientwork" className="uppercase hover:underline backdrop-blur-sm">CLIENT WORK</a>
          <a href="/templateshop" className="uppercase hover:underline">TEMPLATE SHOP</a>
          <a href="/about" className="uppercase hover:underline">ABOUT</a>
          <a
            className="rounded-full bg-[#CFF098] hover:underline px-12 py-2 text-black border-[1px] border-black uppercase hover:opacity-60"
            href="/contact"
          >
            Inquire
          </a>
        </div>
      </div>
    </nav>
  );
}

export default NavLite;
